import type { ComponentPropsWithoutRef } from 'react'

import styles from '@runtime/components/ui/Button.module.scss'

type ButtonVariant = 'solid' | 'ghost' | 'danger'
type ButtonSize = 's' | 'm'

type ButtonProps = ComponentPropsWithoutRef<'button'> & {
  variant?: ButtonVariant
  size?: ButtonSize
  isDisabled?: boolean
}

export function Button({
  variant = 'solid',
  size = 'm',
  isDisabled,
  className,
  ...props
}: ButtonProps) {
  const classes = [
    'btn',
    styles.root,
    variant === 'ghost' ? 'ghost' : '',
    variant === 'ghost' ? styles.ghost : '',
    variant === 'danger' ? 'danger' : '',
    variant === 'danger' ? styles.danger : '',
    size === 's' ? 's' : '',
    size === 's' ? styles.small : '',
    isDisabled ? 'is-disabled' : '',
    isDisabled ? styles.isDisabled : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ')
  return <button className={classes} {...props} />
}
